export default __webpack_public_path__ + "static/media/8.6b4d4268.jpg";